import { useOrderState } from '@order/hooks/useOrderState'
import FrameStock from '@screens/frame/stock'
import { Redirect, useLocalSearchParams } from 'expo-router'

export default function FrameStockPage() {
  const { localOrderId } = useLocalSearchParams<{ localOrderId?: string }>()

  const orders = useOrderState((s) => s.order.items)

  const item = orders.find((item) => item.id === localOrderId)

  if (!item) {
    return <Redirect href="/frame/select" />
  }
  return <FrameStock item={item} />
}
